import api from '../api'
import fetchDelayed from '@/store/helper/fetchDelayed'

const fetch = (context, args, delay=500) => {
  return fetchDelayed.fetch(
    api,
    context,
    "Listado de clases",
    args,
    delay
  );
}

export default {
  fetch,
}
